import script from "./Form8.vue?vue&type=script&setup=true&lang=js"
export * from "./Form8.vue?vue&type=script&setup=true&lang=js"

import "./Form8.vue?vue&type=style&index=0&id=698c053c&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-698c053c"]])

export default __exports__